import { useCallback } from 'react';

import { Button } from '@twilio-paste/core/button';

import { AppSecrets } from '../../../../modules/Apps';
import { Drawer, useDrawer } from '../../../common/Drawer';
import { useAppsTableContext } from '../../AppsTable/AppsTableContext';

import { AppSecretsSection } from './AppSecretsSection';

type AppSecretsDrawerParams = AppSecrets;

export function AppSecretsDrawer({ apiPrimaryKey, apiSecondaryKey }: AppSecretsDrawerParams) {
  const drawer = useDrawer({ visible: true });
  const { setAppSecrets } = useAppsTableContext();

  const handleClose = useCallback(() => {
    setAppSecrets(undefined);
    drawer.hide();
  }, [drawer, setAppSecrets]);

  return (
    <>
      <Drawer state={drawer} aria-label="App Secrets">
        <Drawer.Header title="App Secrets" isDismissible={false}></Drawer.Header>
        <Drawer.Content>
          <AppSecretsSection apiPrimaryKey={apiPrimaryKey} apiSecondaryKey={apiSecondaryKey} />
        </Drawer.Content>
        <Drawer.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Drawer.Footer>
      </Drawer>
    </>
  );
}
